import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFormRegularCheckIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18 3.2c1.25 0 2.35.635 2.995 1.6H22.4c1.765 0 3.2 1.435 3.2 3.2v17.6c0 1.765-1.435 3.2-3.2 3.2H9.6a3.203 3.203 0 0 1-3.2-3.2V8c0-1.765 1.435-3.2 3.2-3.2h1.405A3.6 3.6 0 0 1 14 3.2zm-8.4 4c-.44 0-.8.36-.8.8v17.6c0 .44.36.8.8.8h12.8c.44 0 .8-.36.8-.8V8c0-.44-.36-.8-.8-.8h-.82c-.2 1.8-1.725 3.2-3.58 3.2h-4c-1.855 0-3.38-1.4-3.58-3.2zm8.235 7.995a1.2 1.2 0 0 1 1.94 1.41L15.97 21.84c-.21.285-.535.465-.89.49s-.7-.11-.945-.365l-1.795-1.86a1.2 1.2 0 0 1 1.725-1.665l.805.83 2.965-4.08zM14 5.6c-.665 0-1.2.535-1.2 1.2S13.335 8 14 8h4c.665 0 1.2-.535 1.2-1.2s-.535-1.2-1.2-1.2z" })
});
export default SvgFormRegularCheckIcon;
